import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import ButtonLink from "../../../../components/ButtonLink";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import { ExcelIcon } from "../../../../data/iconImage";
import Table from "../../../../components/Table";
import { ExcelFileHandler } from "../../../../components/ExcelFileHandler";
import SearchFilterRight from "../../../../components/SearchFilterRightBtn";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { getQueryString } from "../../../../utils/Query";
import { useAlert } from "../../../../context/AlertContext";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import JobTypeService from "../../../../services/jobtype.service";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import moment from "moment";

export default function SumEquipment() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const [allWorkNo, setAllWorkNo] = useState()
  const [querySearch, setQuerySearch] = useState()

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ประเภทงาน",
      selector: (row) => row.JobTypeName,
      sortable: true,
      minWidth: "180px"
    },
    {
      name: "เลขที่ใบสั่งงาน",
      selector: (row) => row.SeqNo,
      sortable: true,
      minWidth: "200px"
    },
    {
      name: "วันที่ตรวจรับ",
      label: "RevDate",
      format: (row) => formatDate(row?.RevDate),
      selector: (row) => row.RevDate,
      sortable: true,
      minWidth: "180px"
    },
    {
      name: "เลขที่ตรวจรับ",
      selector: (row) => row.RevNo,
      sortable: true,
      minWidth: "200px"
    },
    {
      name: "รหัสอุปกรณ์/อะไหล่",
      selector: (row) => row.EquipmentCode,
      sortable: true,
      minWidth: "250px"
    },
    {
      name: "Model Number",
      selector: (row) => row.ModelNumber,
      sortable: true,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดอุปกรณ์/อะไหล่",
      selector: (row) => row.Detail,
      sortable: true,
      minWidth: "300px"
    },
    {
      name: "จำนวนรับ",
      selector: (row) => row.ReceivedQuantity,
      sortable: true,
      minWidth: "150px"
    },
    {
      name: "หน่วย",
      selector: (row) => row.Unit,
      sortable: true,
      minWidth: "150px"
    },
    {
      name: "ผู้รับ",
      selector: (row) => row.Receiver,
      sortable: true,
      minWidth: "200px"
    }
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: "",
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: "",
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      // required: true,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "วันที่ตรวจรับระหว่างวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: 'start'
    },
    {
      name: "seq_no", // "jobtype_name",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      noneAsync: true,
      required: true,
      // queryService: (query, value) => {
      //   const q = getQueryString({
      //     seq_no: value, plan_status: "ACCEPT", limit: 100, page: 1,
      //   })
      //   getServiceRequest({
      //     showAlert,
      //     setLoading: () => { },
      //     serviceRequest: TechnicianReceiveService.getSeqNo(q),
      //     callback: (array) => {
      //       const newArray = array.map(arr => ({
      //         seq_no: arr.seqJob.seqNo
      //       }))
      //       setWorkNo(newArray)
      //     }
      //   });
      // }
    },
  ];

  useEffect(() => {
    getMainData()
    fetchSeqNo()
  }, []);

  const getMainData = () => {

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getAllJobTypes(),
      callback: (res) => setJobType(res)
    });
  }

  function initData(data) {
    const newArray = data.map((items) => {
      const Rev_Date = (items.BillOfReqHd.SeqOthersJob?.TechnicianPlan?.TechnicianReceive?.length && items.BillOfReqHd.SeqOthersJob.TechnicianPlan?.TechnicianReceive[0].tech_rev_date) ||
        (items.BillOfReqHd.Seqinstalljob?.TechnicianPlan?.TechnicianReceive?.length && items.BillOfReqHd.Seqinstalljob.TechnicianPlan?.TechnicianReceive[0].tech_rev_date)

      return ({
        Id: items.Id,
        JobTypeName: items.BillOfReqHd.Job_Type_Name || JobType.find(job => job.Id == items.BillOfReqHd.Job_Type_Id)?.Job_Type_Name,
        SeqNo: items.BillOfReqHd.SeqOthersJob?.Seq_Oth_No
          || items.BillOfReqHd.Seqinstalljob?.seq_install_no,
        RevDate: Rev_Date && formatInputDate(Rev_Date, "Local").date,
        RevNo: items.BillOfReqHd.SeqOthersJob?.TechnicianPlan?.TechnicianReceive?.length && items.BillOfReqHd.SeqOthersJob.TechnicianPlan?.TechnicianReceive[0].tech_rev_no ||
          items.BillOfReqHd.Seqinstalljob?.TechnicianPlan?.TechnicianReceive?.length && items.BillOfReqHd.Seqinstalljob.TechnicianPlan?.TechnicianReceive[0].tech_rev_no,
        EquipmentCode: items.Item.Item_Code,
        ModelNumber: items.Item.Item_Model,
        Detail: items.Item.Item_Name_TH || items.Item.Item_Name_EN,
        ReceivedQuantity: items.Iss_Qty,
        Unit: items.Item.Unit,
        Receiver: items.BillOfReqHd.SeqOthersJob?.TechnicianPlan?.tech_mas_name ||
          items.BillOfReqHd.Seqinstalljob?.TechnicianPlan?.tech_mas_name,

      })
    });
    setSearchValue(newArray)
  }

  const handleSearchFilter = (search) => {
    if (!search) {
      setSearchValue([])
      return
    }
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = ({
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search?.start),
      end: toFormatISO(search?.end)
    })
    setQuerySearch(q)
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.getSumEquipItem(getQueryString(q)),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }

  function fetchSeqNo(search) {
    if (!search) {
      if (!allWorkNo) {
        getSeqNoList({}, 'all')
      } else {
        setWorkNo(allWorkNo)
      }
      return
    }

    getSeqNoList(search)
  }
  function getSeqNoList(search, isAll) {
    const q = getQueryString(search)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechnicianReceiveService.getSeqNoPartEquip(q),
      callback: (res) => {
        const data = res.map(d => {
          return { seq_no: d.seqJob?.seqNo }
        })
        if (isAll) {
          setAllWorkNo(data)
        }
        setWorkNo(data)
      }
    });
  }

  const handleValidated = (search, type) => {
    // event.preventDefault();
    if (type == "clear") {
      setSearchValue([])
      setValidated(false)
      setQuerySearch()
    } else if (type == "submit") {
      if (search?.seq_no) {
        setValidated(false)
        handleSearchFilter(search)
      } else {
        setValidated(true)
      }
    } else if (search?.seq_no) {
      setValidated(false)
    }
  };
  return (
    <>
      <CardDisplayComponent
        header={{ title: { text: "ข้อมูลการรับอุปกรณ์/อะไหล่" } }}
        cardClassName="text-center"
        body={{
          element: (
            <Form noValidate validated={validated} >
              <SearchFilterRight
                // data={data}
                inputField={searchInput}
                searchCallback={handleValidated}
                searchByField={{
                  name: 'seq_no',
                  queryService: search => fetchSeqNo(search)
                }}
                fieldClassName={{
                  inputRow: "justify-content-end",
                  // inputRow: "justify-content-end align-items-center",
                  actionButton: "w-auto py-2"
                }}
                field={searchInput}
                backButton={{
                  path: "/service_work/acceptance",
                  state: "CheckEquipment"
                }}
                moreButton={
                  <div className="pb-2">
                    {/* <ButtonLink
                      linkTo="import"
                      stateData={{ name: "EventPlanning" }}
                      buttonClass="me-2 py-2 px-4 text-dark rounded-pill"
                      buttonName="นำเข้าไฟล์ .xlsx"
                      iconSrc={ExcelIcon}
                      iconClass="me-2"
                      iconName="Excel Icon"
                    /> */}
                    <ExcelFileHandler
                      // data={filteredDataToExcel()}
                      columns={columns.map((col) => col.name)}
                    />
                  </div>
                }
              />
            </Form>
          )
        }}
      />

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-dark">
            รายละเอียดอุปกรณ์/อะไหล่
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Table
            data={searchValue}
            column={columns}
            pending={loading}
            searchFilter={searchValue}
          />
          {!loading &&
            <TableLimitPagination
              data={searchValue}
              paginationProps={{
                rowsPerPage: rowsPerPage,
                currentPage: currentPage,
                rowCount: allCountData,
                onChangeRowsPerPage: num => handleSearchFilter({ limit: num, page: 1 }),
                onChangePage: page => handleSearchFilter({ page: page })
              }}
            />
          }
        </Card.Body>
      </Card>
    </>
  );
}
